const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 350;

const PERCENTAGE_COLUMN_TYPE = 'PercentageColumn';
const DEFAULT_COLUMN_PERCENTAGE_NUMBER_FORMAT = 'percentage';

export { DEFAULT_COLUMN_PERCENTAGE_NUMBER_FORMAT, DEFAULT_HEIGHT, DEFAULT_WIDTH, PERCENTAGE_COLUMN_TYPE };
